import { Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { T_AND_C_VERSION } from '../../../constants/app-constants';
import { TNC_DATA } from './tnc-data';

const TermsAndConditions = () => {
    return (
        <React.Fragment>
            <Typography variant='body1' className='opacity-75'> Last updated on {format(new Date(), 'MMMM dd yyyy')}, version - {T_AND_C_VERSION}</Typography>
            <div className='pt-2 pb-4'>
                {TNC_DATA.map(({ title, data }, idx) => {
                    return <Stack component={'ul'} sx={{ paddingInlineStart: '0' }} key={idx}>
                        <Typography className='font-bold my-2'>{`${idx + 1}. ${title}`}</Typography>
                        {data.map((item, idx) => (
                            <React.Fragment key={`${item}-${idx}`}>
                                {typeof item === 'object' ?
                                    <Typography component={'li'} sx={{ listStyle: 'lower-alpha' }} className='ml-6 mb-1 text-justify' variant="body2">
                                        {item?.desc}
                                        <Typography component={'ul'} sx={{ paddingInlineStart: '0' }}>
                                            {item?.items?.map(i => (
                                                <Typography key={i} component={'li'} sx={{ listStyle: 'disc' }} className='ml-6 mb-1 text-justify' variant="body2">{i}</Typography>
                                            ))}
                                        </Typography>
                                    </Typography> :
                                    <Typography component={`${data.length > 1 ? 'li' : ''}`} className='ml-6 mb-1 text-justify' sx={{ listStyle: 'lower-alpha' }} key={`${item}-${idx}`} variant="body2">{`${item}`}</Typography>
                                }
                            </React.Fragment>
                        ))}
                    </Stack>;
                })}
            </div>
        </React.Fragment>
    );
};

export default TermsAndConditions;
